export const CST = {
  true: 'S',
  false: 'N',
};

export default CST;
